module.exports = __webpack_public_path__ + "static/media/dashboard-2.591bdef5.svg";